module.exports = __webpack_public_path__ + "img/view_5.d0c5964a.jpg";